"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strip = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Strip = exports.Strip = function () {
  function Strip(config) {
    (0, _classCallCheck3.default)(this, Strip);

    this.ratio = 0;
    this.groups = [];
    this.width = 0;
    this.height = 0;
    this.isFullWidth = true;

    this.idx = config.idx;
    this.groupsPerStrip = config.groupsPerStrip;
    this.oneRow = config.oneRow;
    this.gallerySize = config.gallerySize;
    this.container = config.container;
  }

  (0, _createClass3.default)(Strip, [{
    key: "addGroup",
    value: function addGroup(group) {
      if (this.hasGroups) {
        this.lastGroup.isLastGroup = false;
      }
      this.groups.push(group);
      group.stripIdx = this.idx;
      this.lastGroup.isLastGroup = true;
      this.lastGroup.stripWidth = this.height * this.ratio;
    }
  }, {
    key: "markAsIncomplete",
    value: function markAsIncomplete() {
      //prevent from the last group to be streched
      this.isFullWidth = false;
      this.lastGroup.isLastGroup = false;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = width;
      if (this.hasGroups) {
        this.lastGroup.stripWidth = width;
      }
    }
  }, {
    key: "resizeToHeight",
    value: function resizeToHeight(height) {
      this.height = height;
      var left = 0;
      var remainder = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.groups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          group.setLeft(left);
          // group.left = (left);
          group.width += remainder; //add the remainder from the last group round
          group.resizeToHeight(height);
          remainder = group.width;
          group.round();
          remainder -= group.width;
          left += group.width;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isFull",
    value: function isFull(newGroup, isLastImage) {

      if (!this.hasGroups) {
        return false;
      }

      var groupsPerStrip = this.groupsPerStrip,
          oneRow = this.oneRow,
          gallerySize = this.gallerySize;


      if (groupsPerStrip > 0) {
        return this.groups.length >= groupsPerStrip;
      }

      var galleryWidth = this.container.galleryWidth;


      var isStripSmallEnough = void 0;
      if (oneRow) {
        isStripSmallEnough = false; //onerow layout is one long strip
      } else {
        var withNewGroup = galleryWidth / (this.ratio + newGroup.ratio) - gallerySize; //start a new strip BEFORE adding the current group
        var withoutNewGroup = galleryWidth / this.ratio - gallerySize; //start a new strip AFTER adding the current group
        if (isNaN(withNewGroup) || isNaN(withoutNewGroup)) {
          isStripSmallEnough = false;
        } else if (withoutNewGroup < 0) {
          //the strip is already too small
          isStripSmallEnough = true;
        } else if (withNewGroup < 0) {
          //adding the new group makes is small enough
          // check if adding the new group makes the strip TOO small
          //so - without the new group, the strip is larger than the required size - but adding the new group might make it too small
          isStripSmallEnough = Math.abs(withoutNewGroup) < Math.abs(withNewGroup);
        } else {
          isStripSmallEnough = false;
        }

        if (isStripSmallEnough && isLastImage) {
          //if it is the last image - prefer adding it to the last strip rather putting it on a new strip
          isStripSmallEnough = Number(Math.abs(withoutNewGroup)) < Math.abs(withNewGroup);
        }
      }

      return isStripSmallEnough;
    }
  }, {
    key: "hasGroups",
    get: function get() {
      return this.groups.length > 0;
    }
  }, {
    key: "lastGroup",
    get: function get() {
      return this.groups[this.groups.length - 1];
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height,
        ratio: this.ratio,
        isFullWidth: this.isFullWidth
      };
    }
  }]);
  return Strip;
}();